import Vuex from 'vuex';
import auth from './modules/auth';

import general from './modules/general';


import carMakes from './modules/carMakes';
import carModels from './modules/carModels';
import blogs from './modules/blogs';
import documents from './modules/documents';
import questions from './modules/questions';
import videos from './modules/videos';
import carYears from './modules/carYears';
import comments from './modules/comments';
import interaction from './modules/interaction';
import notifications from './modules/notifications';
const store = new Vuex.Store({
    modules: {
        admin: {
            namespaced: true,
            modules: {
                auth: auth,
                general: general,
                carMakes: carMakes,
                carModels: carModels,
                blogs: blogs,
                documents: documents,
                questions: questions,
                videos: videos,
                carYears: carYears,
                comments: comments,
                interaction: interaction,
                notifications: notifications
            },
        }
    }
})

export default store;